import { Component } from '@angular/core';

@Component({
  selector: 'app-tender-list',
  templateUrl: './tender-list.component.html',
  styleUrls: ['./tender-list.component.css']
})
export class TenderListComponent {
//   tenderDetails = {
//     tenderId: '2025_UAD_418471_2',
//     tenderType: 'Open Tender',
//     paymentMode: 'Online',
//     covers: [
//       { number: 1, type: 'Fee/PreQual/Technical', documentType: '.pdf' },
//       { number: 2, type: 'Finance', documentType: '.xls' }
//     ],
//     fee: {
//       tenderFee: 5000,
//       processingFee: 443,
//       totalFee: 5443
//     },
//     emd: {
//       amount: 28135,
//       type: 'Fixed',
//       exemptionAllowed: false
//     },
//     workTitle: 'CONSTRUCTION OF CC ROAD DRAIN PAVER BLOCK FITTING AND BEAUTIFICATION...',
//     value: 37051000,
//     location: 'MUNICIPAL COUNCIL JORA',
//     bidDates: {
//       published: '23-Apr-2025 12:00 PM',
//       bidStart: '29-Apr-2025 09:00 AM',
//       bidEnd: '26-May-2025 05:30 PM',
//       openDate: '28-May-2025 11:00 AM'
//     },
//     documents: [
//       { name: 'Tendernotice_1.pdf', size: '1152.25 KB' },
//       { name: 'BOQ_493312.xls', size: '248.50 KB' }
//     ]
//   };
// }
tenderDetails = {
  tenderId: '2025_UAD_418471_2',
  tenderType: 'Open Tender',
  formOfContract: 'Percentage',
  category: 'Works',
  paymentMode: 'Online',
  multiCurrencyAllowed: false,
  covers: [
    { number: 1, type: 'Fee/PreQual/Technical', documentType: '.pdf' },
    { number: 2, type: 'Finance', documentType: '.xls' }
  ],
  fee: {
    total: 5443,
    processing: 443
  },
  emd: {
    amount: 28135,
    type: 'Fixed'
  },
  work: {
    title: 'CONSTRUCTION OF CC ROAD...',
    description: 'CONSTRUCTION OF CC ROAD DRAIN...',
    location: 'MUNICIPAL COUNCIL JORA',
    pincode: '476221',
    value: 3751000,
    period: 180
  },
  dates: {
    published: '23-Apr-2025 12:00 PM',
    bidStart: '29-Apr-2025 09:00 AM',
    bidEnd: '26-May-2025 05:30 PM',
    opening: '28-May-2025 11:00 AM'
  },
  documents: [
    { name: 'Tendermnotice_1.pdf', size: '1152.25' },
    { name: 'BOQ_493312.xls', size: '248.50' }
  ],
  authority: {
    name: 'MUNICIPAL COUNCIL JORA',
    address: 'MUNICIPAL COUNCIL JORA'
  }
};

coverColumns: string[] = ['number', 'type', 'docType'];
}